module.exports = __webpack_public_path__ + "img/Picture-Article.6254211b.jpg";